module.exports = __webpack_public_path__ + "1b241e0785e89dd95dc6cdabe2f6ff1d.png";